export default __webpack_public_path__ + "static/media/family-ES.95b2a80d.png";